import { render, staticRenderFns } from "./MilestoneStep1.vue?vue&type=template&id=afdcea2a&scoped=true&"
import script from "./MilestoneStep1.vue?vue&type=script&lang=js&"
export * from "./MilestoneStep1.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneStep1.vue?vue&type=style&index=0&id=afdcea2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdcea2a",
  null
  
)

export default component.exports